import { datelike, object, uuidv4 } from "decoders";
export const meResponseDecoder = object({
    createdAt: datelike,
    userId: uuidv4,
});
